export default {"src":"/_next/static/media/upload-folder.2d53f5c3.svg","height":12,"width":12,"blurWidth":0,"blurHeight":0};